module.exports = new __parcel__URL__("movies.8d8423e6.png").toString();